import type { SegmentedOption } from './setting-controls'

export type ReadingDirection = 'ttb' | 'rtl' | 'ltr'
/** free: 指の動きに合わせて自由にスクロール / snap: 1 ページずつめくる */
export type DragMode = 'free' | 'snap'
export type PageMode = 'single' | 'dual' | 'dual-cover'
export type DualReadingOrder = 'ltr' | 'rtl'

/** コミック・PDF で共通の読み方の設定 */
export type ReaderLayout = {
  direction: ReadingDirection
  dragMode: DragMode
  pageMode: PageMode
  /** 縦方向で見開きにしたときの左右の並び */
  dualReadingOrder: DualReadingOrder
}

export const READING_DIRECTION_OPTIONS: SegmentedOption<ReadingDirection>[] = [
  { value: 'ttb', label: '縦' },
  { value: 'rtl', label: '右→左' },
  { value: 'ltr', label: '左→右' },
]

export const DRAG_MODE_OPTIONS: SegmentedOption<DragMode>[] = [
  { value: 'free', label: 'スクロール', title: '指の動きに合わせて自由にスクロール' },
  { value: 'snap', label: 'ページめくり', title: '1 ページずつめくる' },
]

export const PAGE_MODE_OPTIONS: SegmentedOption<PageMode>[] = [
  { value: 'single', label: '単ページ' },
  { value: 'dual', label: '見開き' },
  { value: 'dual-cover', label: '表紙+見開き' },
]

export const DUAL_READING_ORDER_OPTIONS: SegmentedOption<DualReadingOrder>[] = [
  { value: 'rtl', label: '右→左' },
  { value: 'ltr', label: '左→右' },
]
